import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Courses.module.css';
import { AuthContext } from '../Providers/AuthContext';
import GlobalHeader from '../GlobalHeader';
import { playUISound } from '../../utils/UISoundEffects';

function Courses() {
  const navigate = useNavigate();
  const { isPremium, accountType, profileLoading } = useContext(AuthContext);

  useEffect(() => {
    // Wait for profile to load before checking premium status
    if (!profileLoading && (!isPremium || accountType !== 'real')) {
      navigate('/main');
    }
  }, [isPremium, accountType, profileLoading, navigate]);

  // Show loading while checking access
  if (profileLoading) {
    return (
      <div className={styles.container}>
        <GlobalHeader />
        <div className={styles.loading}>Loading...</div>
      </div>
    );
  }

  // Only render if user has premium access
  if (!isPremium || accountType !== 'real') {
    return null;
  }

  return (
    <div className={styles.container}>
      <GlobalHeader />
      <div className={styles.content}>
        <div className={styles.header}>
          <h1 className={styles.title}>🎓 Premium Courses</h1>
          <div className={styles.premiumBadge}>PREMIUM</div>
        </div>

        <div className={styles.placeholderContent}>
          <div className={styles.icon}>🎯</div>
          <h2 className={styles.placeholderTitle}>Course Library Coming Soon!</h2>
          <p className={styles.placeholderText}>
            This premium feature is under development. Soon you'll have access to:
          </p>
          <ul className={styles.featureList}>
            <li>📚 Comprehensive strategy courses</li>
            <li>🏆 Pro player masterclasses</li>
            <li>🎯 Opening repertoire guides</li>
            <li>🧠 Tactical pattern recognition</li>
            <li>👑 King selection strategies</li>
            <li>🎭 Bluffing and deception techniques</li>
            <li>📊 Meta analysis and adaptation</li>
          </ul>
          <button className={styles.backButton} onClick={() => { playUISound(); navigate('/main'); }}>
            Back to Main Page
          </button>
        </div>

        <div className={styles.statusBar}>
          <span className={styles.statusText}>✅ Premium Access Active</span>
          <span className={styles.statusText}>🔓 Full Access Granted</span>
        </div>
      </div>
    </div>
  );
}

export default Courses;
